import { TableColumnMeta } from "ds/components/Table/types";

import { SortableColumns } from "../constants";

export const WORKER_POOLS_TABLE_STORAGE_KEY = "workerPoolsListTable";

export enum WORKER_POOLS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  LABELS = "LABELS",
  SPACE = "SPACE",
  WORKERS = "WORKERS",
  BUSY = "BUSY",
  QUEUE = "QUEUE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const WORKER_POOLS_TABLE_COLUMNS_CONFIG: Record<WORKER_POOLS_COLUMN_ID, TableColumnMeta> = {
  [WORKER_POOLS_COLUMN_ID.NAME]: {
    id: WORKER_POOLS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [WORKER_POOLS_COLUMN_ID.DESCRIPTION]: {
    id: WORKER_POOLS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 120,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [WORKER_POOLS_COLUMN_ID.LABELS]: {
    id: WORKER_POOLS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [WORKER_POOLS_COLUMN_ID.SPACE]: {
    id: WORKER_POOLS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 100,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [WORKER_POOLS_COLUMN_ID.WORKERS]: {
    id: WORKER_POOLS_COLUMN_ID.WORKERS,
    title: "Workers",
    minWidth: 90,
    defaultWidth: 110,
    maxWidth: 200,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [WORKER_POOLS_COLUMN_ID.BUSY]: {
    id: WORKER_POOLS_COLUMN_ID.BUSY,
    title: "Busy",
    minWidth: 90,
    defaultWidth: 110,
    maxWidth: 200,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [WORKER_POOLS_COLUMN_ID.QUEUE]: {
    id: WORKER_POOLS_COLUMN_ID.QUEUE,
    title: "Queue",
    minWidth: 90,
    defaultWidth: 110,
    maxWidth: 200,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [WORKER_POOLS_COLUMN_ID.DROPDOWN]: {
    id: WORKER_POOLS_COLUMN_ID.DROPDOWN,
    title: "Worker pool actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    allowsSorting: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const WORKER_POOLS_SORT_CONFIG: Partial<Record<WORKER_POOLS_COLUMN_ID, string>> = {
  [WORKER_POOLS_COLUMN_ID.NAME]: SortableColumns.NAME,
  [WORKER_POOLS_COLUMN_ID.SPACE]: SortableColumns.SPACE,
  [WORKER_POOLS_COLUMN_ID.WORKERS]: SortableColumns.WORKERS,
  [WORKER_POOLS_COLUMN_ID.BUSY]: SortableColumns.BUSY,
  [WORKER_POOLS_COLUMN_ID.QUEUE]: SortableColumns.QUEUE,
};
